"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductDetailReviewCount = void 0;
const react_redux_1 = require("react-redux");
const ProductDetailV2Container_1 = require("../containers/product/ProductDetailV2Container");
const ProductSelector_1 = require("../redux/product/selectors/ProductSelector");
const common_types_1 = require("@as-react/common-types");
const useProductDetailReviewCount = () => {
    const { tabs: productDetailTabs } = (0, ProductDetailV2Container_1.useProductDetailContext)();
    const reviewTab = productDetailTabs === null || productDetailTabs === void 0 ? void 0 : productDetailTabs.find(tab => tab.type === common_types_1.ProductDetailTabTypes.REVIEWS);
    const userReview = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetProductReview)());
    const userReviewCount = (reviewTab === null || reviewTab === void 0 ? void 0 : reviewTab.showEndUserReview) ? Number(userReview === null || userReview === void 0 ? void 0 : userReview.numberOfScores) : 0;
    const expertReviewCount = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetExpertReviews)()).length;
    const totalReviewCount = expertReviewCount + userReviewCount;
    return {
        totalReviewCount,
        expertReviewCount,
        userReviewCount,
    };
};
exports.useProductDetailReviewCount = useProductDetailReviewCount;
